'use strict';

var _module2 = require('../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('webComponent', function () {
  return {
    restrict: 'E',
    transclude: true,
    // no_animation fixes compatibility with some commonly used WordPress 
    // templates. It prevents them from redirecting on click to elements with
    // an empty href (such as slider next/previous buttons, accordion 
    // headings)
    //
    // winres-web-component is the class that is added in PostCSS to all
    // (or most) CSS. 
    template: '<div responsive><div class="no_animation winres-web-component"><div locale-class ng-transclude></div></div><style custom-styles="webComponents"></style></div>'
  };
});

// Like webComponent, but creates spans instead of divs
// Makes web component responsive and wraps it with correct wrappers to work
// with the PostCSS-transformed CSS.
_module3.default.directive('webComponentSpan', function () {
  return {
    restrict: 'E',
    transclude: true,
    template: '<span responsive><span class="no_animation winres-web-component"><span locale-class ng-transclude></span></span></span>'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/directives/webComponent.js
// module id = 507
// module chunks = 2